import { useRoutes } from "react-router";

import { Sentry } from "@shared/utils/init-tracking";

import { Lazy } from "@shared/components/ui/lazy";
import { getAdminRoutes } from "@shared/features/admin/routes";
import { useApp } from "@shared/features/app/hooks/use-app";
import { MaintenanceGate } from "@shared/features/maintenance/maintenance-gate";
import { getAuthRoutes } from "@shared/features/auth/routes";

const Root = Lazy(() => import("@shared/features/app/pages/root"), "Root");
const AdminRootStandalone = Lazy(
  () => import("@shared/features/admin/pages/admin-root-standalone"),
  "AdminRootStandalone"
);

const NotAuthorized = Lazy(
  () => import("./pages/not-authorized"),
  "NotAuthorized"
);

const AppBase: React.FC = () => {
  const { initialized } = useApp();

  const element = useRoutes([
    { path: "/", element: <Root /> },
    ...getAuthRoutes({ onlyLogin: true }),
    {
      path: "/not-authorized",
      element: <NotAuthorized />,
    },
    {
      path: "/app",
      element: <AdminRootStandalone />,
      children: [...getAdminRoutes()],
    },
  ]);

  return (
    <MaintenanceGate>{initialized ? element : null}</MaintenanceGate>
  );
};

export const App = Sentry.withProfiler(AppBase);
